import './UserBoardHeader.less';

import clsx from 'clsx';
import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import HamburgerIcon from '@/icons/HamburgerIcon';
import TournamentCupIcon from '@/icons/TournamentCupIcon';
import { navigate } from '@/routing';
import { MENU, MONEY_DEPOSIT, REGISTRATION, TOURNAMENTS } from '@/routing/routes';
import UserAvatar from '@/common/components/user-avatar/UserAvatar';
import i18n from '@i18n';
import { fireGAEvent, TOURNAMENT } from '@/analytics';
import { Button } from 'nike-ui/src/components/button/Button';
import { formatMoney } from '@/common/client';
import PopupNg from '@/ui/PopupNg';
import { loadTournamentCounts } from '@/tournaments/handlers';
import { accountUserData$ } from '@/account/subs';
import { activeTournamentCount$, unseenTournamentCount$ } from '@/tournaments/subs';
import { hideDeposit$ } from 'nike-ui/src/components/settings/h&s';
import { isProfileOlympiaEnabled } from 'nike-ui/src/profiles';
import { registrationQueryParams } from 'nike-ui/src/components/dwh-tracking/api';
import { SvgIcon } from 'nike-ui/src/icons/SvgIcon';
import { accountNewMessages$ } from '@/message/subs';

function UserBoardHeader({ children, pageFixerClassName, pageHeaderClassName, noShadow = false }) {
    const { subscribe } = useReframe();
    const userData = subscribe(accountUserData$);
    const newMessageCount = subscribe(accountNewMessages$);
    const loggedIn = !!userData.cisloZmluvy;
    const { avatar, bonuses, vip, vipKasino } = userData;
    const sumBonuses = (bonuses?.activeCount || 0) + (bonuses?.offeredCount || 0);
    const userNotificationsCounter = sumBonuses + newMessageCount;

    function openLogin() {
        fireGAEvent('Homepage', 'Prihlasit sa', 'Prihlasenie');
        dispatch(['login.openScreen']);
    }

    function openRegistration(e) {
        fireGAEvent('Homepage', 'Registracia');
        e.stopPropagation();
        navigate(REGISTRATION, null, registrationQueryParams('HEADER_BUTTON'));
    }

    function openVipDialog(e) {
        e.stopPropagation();
        e.preventDefault();
        fireGAEvent('Vip User Dialog', 'Open');
        PopupNg.dispatcher.open('dialog/article', { articleCode: 'vip-klient' });
    }

    return (
        <>
            <div
                className={clsx('user-board page-header-sticker', pageHeaderClassName, {
                    'non-shadow': noShadow
                })}
            >
                <div className="user-board-ng justify-between">
                    <div className="user-board-ng-nav">
                        <button onClick={() => navigate(MENU)}>
                            <HamburgerIcon />
                        </button>

                        {loggedIn && isProfileOlympiaEnabled() && <TournamentIcon />}
                        {(vip || vipKasino) && (
                            <button onClick={openVipDialog}>
                                <SvgIcon imgId="vip" width={20} height={20} className="user-board-header-vip" />
                            </button>
                        )}
                    </div>
                    <div className="user-board-ng-profile px-15 py-10">
                        {loggedIn ? (
                            <>
                                <UserBoardHeaderDeposit />
                                <button
                                    className={clsx({ 'item-badge': userNotificationsCounter })}
                                    onClick={() => navigate(MENU)}
                                    data-badge={userNotificationsCounter}
                                >
                                    <UserAvatar avatarId={avatar} />
                                </button>
                            </>
                        ) : (
                            <>
                                <Button label={i18n('login.register')} onClick={openRegistration} />
                                <Button label={i18n('jsp.login.Prihlasit')} primary onClick={openLogin} />
                            </>
                        )}
                    </div>
                </div>
                {children}
            </div>
            <div className={clsx('page-header-fixer', pageFixerClassName)} />
        </>
    );
}

export function UserBoardHeaderDeposit() {
    const { subscribe } = useReframe();
    const userData = subscribe(accountUserData$);
    const { disponible, points } = userData;
    const showDeposit = !subscribe(hideDeposit$);

    if (!showDeposit) {
        return null;
    }

    function goToNikeDeposit(e) {
        e.stopPropagation();
        e.preventDefault();
        fireGAEvent('Main menu', 'Moj ucet - Vklad a vyber z uctu');
        navigate(MONEY_DEPOSIT);
    }

    return (
        <button onClick={goToNikeDeposit} className="balance-section">
            <div className="balance-section-money">{formatMoney(disponible)}</div>
            <div>{formatMoney(points, 'NIK')}</div>
        </button>
    );
}

function TournamentIcon() {
    useEffect(() => dispatch(loadTournamentCounts), []);

    const { subscribe } = useReframe();
    const unseenTournamentCount = subscribe(unseenTournamentCount$);
    const activeTournamentCount = subscribe(activeTournamentCount$);

    function goToTournaments(e) {
        e.preventDefault();
        e.stopPropagation();
        fireGAEvent(TOURNAMENT, 'icon-top');
        navigate(TOURNAMENTS);
    }
    return (
        <button className={clsx('user-board-tournaments p-rel')} onClick={goToTournaments}>
            {unseenTournamentCount ? (
                <span className="badge p-abs" data-atid="tournament-news-count-badge">
                    {unseenTournamentCount}
                </span>
            ) : null}
            <TournamentCupIcon
                width="24"
                height="18"
                className={clsx({ 'tournament-cup-active': activeTournamentCount > 0 })}
            />
        </button>
    );
}

export default UserBoardHeader;
